module.exports = "data:application/octet-stream;base64,cHJhZ21hIHNvbGlkaXR5IF4wLjQuMjQ7Cgpjb250cmFjdCBHdWFyZExpYnJhcnkgewogIGJvb2wgcHVibGljIGNvbXBsZXRlOwp9Cgpjb250cmFjdCBTdHJvbmdCb3ggewogIGFkZHJlc3MgcHVibGljIGd1YXJkTGliOwoKICBjb25zdHJ1Y3RvcihhZGRyZXNzIF9ndWFyZExpYnJhcnkpIHB1YmxpYyB7CiAgICBndWFyZExpYiA9IF9ndWFyZExpYnJhcnk7CiAgfQoKICBmdW5jdGlvbiBwYXNzKCkgcHVibGljIHZpZXcgcmV0dXJucyAoYm9vbCkgewogICAgcmV0dXJuIEd1YXJkTGlicmFyeShndWFyZExpYikuY29tcGxldGUoKTsKICB9Cn0K"


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/StrongBox.sol
// module id = 1342
// module chunks = 0